import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import { TagBox, TextBox, Button } from "devextreme-react";
import { addUser, getRoles, getUserCode } from "../../../api/companyUserApi";
import React, { useState, useEffect } from "react";
import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import CustomDropdown from "../../../components/customDropDown/CustomDropdown";
import SaveNewHeader from "../../../components/customPageHeader/SaveNewHeader";
import CustomOtpPopup from "../../../components/customPopup/CustomOtpPopup";
import CustomTextBox from "../../../components/customTextBox/CustomTextBox";
import { custStatusDataSource2 } from "../../customers/data";
import { LoadPanel } from "devextreme-react";
import { useAuth } from "../../../contexts/auth";
import { generateOtpWithAction } from "../../../api/forgotPwdApi";
import { validateEmail } from "../../../components/login-form/LoginForm";
import { useNavigate } from "react-router-dom";
import AddNewSubHeader from "../../../components/customPageHeader/SaveNewHeader";
import "./AddUsersPage.scss";
export default function AddUsersPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isUserOtpPopupVisible, setisUserOtpPopupVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [chkOtpVerify, setChkOtpVerify] = useState("N");
  const [roleDataSource, setRoleDataSource] = useState([]);
  const [projectDataSource, setProjectDataSource] = useState([]);

  const [formData, setFormData] = useState({
    // cmpusercode: "",
    cmpuserusername: "",
    cmpuseremail: "",
    // cmpuserpassword: "",
    cmpusercontactnumber: "",
    cmpuserstatus: "active",
    cmpuserisdeleted: 0,
    companytransid: user?.companytransid,
    // isotpverified: "N",
    // passwordreq: "changed",
    // roles: [],
    projects: [],
  });

  // const fetchRoles = async () => {
  //   try {
  //     const response = await getRoles();

  //     if (response && Array.isArray(response)) {
  //       setRoleDataSource(response);
  //     }
  //   } catch (error) {
  //     ToastDisplayer("error", "Failed to load roles");
  //   }
  // };

  const get_user_code = async () => {
    try {
      setLoading(true);
      const response = await getUserCode();
      if (response.data && response.data.user_code) {
        setFormData((prevState) => ({
          ...prevState,
          cmpusercode: response.data.user_code,
        }));
      } else {
        ToastDisplayer("error", "user code not generated");
      }
    } catch (error) {
      ToastDisplayer("error", "user code not generated");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    get_user_code();
    // fetchRoles();

    // ✅ Temporary mock projects (remove when API ready)
    setProjectDataSource([
      { transid: 1, projectname: "CRM System" },
      { transid: 2, projectname: "E-Commerce App" },
      { transid: 3, projectname: "HRMS Portal" },
      { transid: 4, projectname: "Inventory Management" },
    ]);
  }, []);

  const formValidation = () => {
    const newErrors = {};

    if (!formData.cmpuserusername.trim()) {
      newErrors.cmpuserusername = "User Name is Required.";
    }
    if (!formData.cmpuseremail.trim()) {
      newErrors.cmpuseremail = "Email is Required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.cmpuseremail)) {
      newErrors.cmpuseremail = "Invalid Email Format";
    }
    // if (!formData.projects || formData.projects.length === 0) {
    //   newErrors.projects = "At least one project must be selected.";
    // }

    // user password validation
    // if (!formData.cmpuserpassword.trim()) {
    //   newErrors.cmpuserpassword = "Password is Required.";
    // } else if (formData.cmpuserpassword.length > 15)
    //   newErrors.cmpuserpassword = "Password must not be greater 15 characters";

    // contact number validation
    if (!formData.cmpusercontactnumber.trim()) {
      newErrors.cmpusercontactnumber = "Contact Number is Required.";
    } else if (!/^\d{3,15}$/.test(formData.cmpusercontactnumber)) {
      newErrors.cmpusercontactnumber =
        "Contact number must be numeric and must be between 3 to 15";
    }

    // user status validation
    if (!formData.cmpuserstatus) {
      newErrors.cmpuserstatus = "Status is required.";
    }

    setErrors(newErrors);
    Object.values(newErrors).forEach((error) => {
      ToastDisplayer("error", error);
    });
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const handleInputChange = (field) => {
    return (e) => {
      setFormData((prevState) => ({
        ...prevState,
        [field]: e.value,
      }));
    };
  };

  const handleSaveDetails = async () => {
    if (!formValidation()) return;

    try {
      setLoading(true);
      const modifiedFormData = {
        ...formData,
        cmpuserstatus:
          formData.cmpuserstatus === "active" ? "active" : "inactive",
        // isotpverified: chkOtpVerify,
      };
      const response = await addUser(modifiedFormData);

      if (response.data && response.data.transid) {
        ToastDisplayer("success", "User Added Successfully.");
        navigate("/Developer");
      } else {
        ToastDisplayer("error", response.data.message || "Failed to Add.");
      }
    } catch (error) {
      ToastDisplayer("error", error?.response?.data?.error);
      if (error.response?.data?.errors) {
        ToastDisplayer(
          "error",
          Object.entries(error.response?.data?.errors).map((x) => {
            return x[1][0];
          }),
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const toggleUserOtpPopup = () => {
    setisUserOtpPopupVisible(!isUserOtpPopupVisible);
  };

  // const handleUserOtpPopup = async () => {
  //   try {
  //     const trimmedEmail = formData.cmpuseremail.trim();
  //     if (!trimmedEmail || !validateEmail(trimmedEmail)) {
  //       return ToastDisplayer(
  //         "error",
  //         !trimmedEmail
  //           ? "Email address cannot be empty."
  //           : "Please enter a valid email address.",
  //       );
  //     }

  //     setLoading(true);

  //     const result = await generateOtpWithAction(formData.cmpuseremail, "C");
  //     if (result?.data) {
  //       ToastDisplayer("success", result.data.message);
  //       setisUserOtpPopupVisible(!isUserOtpPopupVisible);
  //     }
  //   } catch (error) {
  //     ToastDisplayer("error", error.response.data.error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <div>
        <div className="addCustPage">
          {/* <div className="crumbMargin">
            <BreadCrumb />
          </div> */}
          <div className="headerComponent">
            <div className="headerContainer1">
              <div className="title">
                <span class="icon-size">
                  <i class="ri-user-add-line"></i>
                </span>
                {/* <p>Add Developer</p> */}
                <BreadCrumb />
              </div>
            </div>
            <div className="headerContainer2">
              <Button
                text="Cancel"
                // icon="add"
                // stylingMode="outlined"
                type="default"
                width={140}
                onClick={handleCancel}
              />

              <Button
                className="saveBtn"
                text="Save Details"
                // icon="add"
                stylingMode="outlined"
                type="default"
                width={140}
                onClick={handleSaveDetails}
              />

              {/* <CustomPageHeader
                          // titleName={"Customers"}
                          handleCreateNew={handleCreateNew}
                          btnText={"Add Client"}
                        /> */}
            </div>
          </div>
          {/* <AddNewSubHeader
            titleName={"Add User"}
            handleSaveDetails={handleSaveDetails}
            handleCancel={handleCancel}
            cancelText={"Cancel"}
            saveText={"Save Details"}
            iconClass={"ri-user-add-line"}
          /> */}
          <div className="customerMain">
            <div className="mainAddCustSection">
              <CustomTextBox
                label="Developer Code"
                placeholder="Code is auto-generated?"
                value={formData.cmpusercode}
                readOnly
                // onChange={handleInputChange("cmpusercode")}
                type="text"
              />
              <CustomTextBox
                label="Developer Name"
                placeholder="What's the name?"
                value={formData.cmpuserusername}
                onChange={handleInputChange("cmpuserusername")}
                type="text"
              />
              <div className="MyTextBox">
                <label className="TextBoxLabel">
                  Email Address <span className="requiredClass">*</span>
                </label>

                <div className="TextBoxWrapper">
                  <TextBox
                    value={formData.cmpuseremail}
                    onValueChanged={handleInputChange("cmpuseremail")}
                    width={"100%"}
                    stylingMode="outlined"
                    className="TextBoxMain"
                    placeholder="What's email address?"
                    mode="text"
                  />
                  {/* <span
                    className="email-arrow-icon"
                    onClick={handleUserOtpPopup}
                  >
                    <i className="ri-arrow-right-line"></i>
                  </span> */}
                </div>
              </div>
              {/* <CustomTextBox
                label="Password"
                placeholder="Enter Password"
                value={formData.cmpuserpassword}
                onChange={handleInputChange("cmpuserpassword")}
                type="password"
              /> */}
              <CustomTextBox
                label="Contact Number"
                placeholder="Contact Number"
                value={formData.cmpusercontactnumber}
                onChange={handleInputChange("cmpusercontactnumber")}
                type="text"
              />
              <CustomDropdown
                label={"Status"}
                myDataSource={custStatusDataSource2}
                placeholder={"Select Status"}
                value={formData.cmpuserstatus}
                setSelectedValue={handleInputChange("cmpuserstatus")}
              />
            </div>
          </div>
        </div>

        {/* <CustomOtpPopup
          visible={isUserOtpPopupVisible}
          onClose={toggleUserOtpPopup}
          emailOtp={formData.cmpuseremail}
          setLoading={setLoading}
          setChkOtpVerify={setChkOtpVerify}
        /> */}
      </div>
    </>
  );
}
